import { ChakraProvider as BaseChakraProvider } from "@chakra-ui/provider";
import defaultTheme from "@chakra-ui/theme";
export var ChakraProvider = BaseChakraProvider;
ChakraProvider.defaultProps = {
  theme: defaultTheme
};
//# sourceMappingURL=chakra-provider.js.map